export default class EmailValidationResult {
  public emailAddress: string = '';

  public isValid: boolean | null = null;

  public validationStarted: Date | null = null;

  public validationEnded: Date | null = null;

  public validationInProgress(): boolean {
    return this.validationStarted !== null && this.validationEnded === null;
  }
}
